export default __webpack_public_path__ + "73e6d98ec2da8fea5a98e7458a37b05e.svg";